import { useEffect, useState } from "react";
import { Settings as SettingsAPI } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Copy, LinkSimple } from "@phosphor-icons/react";

export default function BookingLink() {
  const [s, setS] = useState(null);
  useEffect(() => { SettingsAPI.get().then(setS); }, []);

  if (!s) return <div className="p-10 text-sm text-neutral-500">Loading...</div>;

  const bookUrl = `${window.location.origin}/book/${s.booking_slug}`;

  const copy = () => {
    navigator.clipboard.writeText(bookUrl);
    toast.success("Link copied");
  };

  return (
    <div data-testid="booking-link-page">
      <PageHeader
        overline="Public · Self-serve"
        title="Booking Link"
        description="Share this link with prospects so they can book a meeting time on your calendar."
        testId="booking-header"
      />
      <div className="p-10 max-w-2xl space-y-6">
        <Card className="p-8 rounded-md border-neutral-200" data-testid="link-card">
          <div className="overline mb-2 flex items-center gap-2"><LinkSimple size={12} /> Your public booking URL</div>
          <div className="flex items-center gap-3 mt-3">
            <Input readOnly value={bookUrl} className="font-mono text-sm" data-testid="booking-url" />
            <Button variant="outline" onClick={copy} data-testid="copy-btn"><Copy size={14} className="mr-2" />Copy</Button>
            <a href={bookUrl} target="_blank" rel="noreferrer">
              <Button className="bg-neutral-900 hover:bg-black text-white" data-testid="open-preview-btn">Preview</Button>
            </a>
          </div>
          <div className="mt-6 text-sm text-neutral-500">
            Anyone with this link can book a discovery call. Bookings appear in your Appointments and a
            confirmation email is sent to the prospect with calendar links (Google, Outlook, Office 365, Apple / .ics).
          </div>
        </Card>

        <Card className="p-8 rounded-md border-neutral-200 bg-neutral-50">
          <div className="overline mb-2">How it works</div>
          <ol className="mt-3 text-sm text-neutral-700 space-y-2 list-decimal pl-5">
            <li>Share the URL in your outreach or on social profiles.</li>
            <li>Prospects pick a time and provide their name + email.</li>
            <li>Appointment auto-lands in your Appointments list.</li>
            <li>Prospect receives a confirmation email with calendar links for every major provider.</li>
          </ol>
        </Card>
      </div>
    </div>
  );
}
